
export enum BookingValidationItems {
  people = 'people',
  tables = 'tables',
  selectedTime = 'selectedTime',
  staffName = 'staffName'
}

export interface ITabValidationRules {
  selectedTab: number;
  displayErrors: number;
  forceGuestListValidation: boolean;
}

export interface ITabValidationSwitches {
  customerValid: boolean;
  detailsValid: boolean;
  paymentValid: boolean;
  guestListValid: boolean;
  isCovidGuestMode: boolean;
  isBookingOption: boolean;
  isRecurringBooking: boolean;
  bookingOptionsValid: boolean;
}
